import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=6e46300e&scoped=true"
import script from "@/views/Settings/Brands/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Brands/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Brands/create-dialog.scss?vue&type=style&index=0&id=6e46300e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e46300e",
  null
  
)

export default component.exports